// Allows to use the data-attribute "confirm" to show a js-dialog
$( function() {
  $( "[data-confirm]" ).on( "click submit", function() {
    return confirm( $( this ).data( "confirm" ) );
  } );
} );
